import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TableCell,
  TablePagination,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  DeleteOutline,
  FilterList,
  FirstPage,
  LastPage,
  Clear,
  Edit,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
  InfoOutlined as InfoOutlinedIcon,
  SettingsBackupRestore as ReverseIcon,
  Search as SearchIcon,
  ExpandMore as ExpandMoreIcon,
} from "@material-ui/icons";
import { withStyles } from "@material-ui/styles";
import React, { Component, forwardRef } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Alert, Autocomplete, Grid } from "@mui/material";

import GridContainer from "../../components/Custom/Grid/GridContainer";
import GridItem from "../../components/Custom/Grid/GridItem";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { format, subDays } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import MaterialTable from "../../components/MaterialTable";
import TextField2 from "@mui/material/TextField";
import GetAppIcon from "@material-ui/icons/GetApp";

import ApiService from "../../ApiService";

import CustomTooltip from "../../components/Custom/Tooltip/Tooltip";
import CheckIcon from "@material-ui/icons/Check";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.gray.light,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    marginLeft: 0,
    minWidth: "100%",
  },
  button: {
    minWidth: "50%",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class DisputeInfoComponent extends Component {
  constructor(props) {
    super();
    this.state = {
      failed: false,
      failed2: false,
      success: false,
      success2: false,
      resMsg2: null,
      responseMessage: null,
      responseMessage2: null,
      fromDate: subDays(new Date(), 20),
      toDate: new Date(),
      disputeStatus: "",
      evidenceType: "",
      loading: false,
      result: [],
      numberRowPerPage: 20,
      totalRow: 0,
      pageNumber: 0,
      sampleData: [],
      acceptPanelVisible: false,
      rejectPanelVisible: false,
      uploadedFiles: [],
      disputeId: null,
      isAccepted: null,
      isRejected: null,
      rejectReason: null,
      transactionId: null,
      merchantId: null,
      DetailPanelVisible: false,
      failed3: false,
      resMsg: null,
      disputeTxnId: null,
      selectedMerchant: null,
      merchants: [],
      files: [],
      previousDisputeStatus: null,
      firstName: null,
      lastName: null,
      customerPhone: null,
      address: null,
      email: null,
      isAccepted: null,
    };
    this.reloadTransactions = this.reloadTransactions.bind(this);
  }

  componentDidMount() {
    this.fetchAllMerchants();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.success && prevState.success !== this.state.success) {
      this.clearMessage();
    }
    if (this.state.failed && prevState.failed !== this.state.failed) {
      this.clearMessage();
    }
  }
  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success: false,
        failed: false,
        responseMessage: null,
      });
    }, 2000);
  };
  handleStatusSelectChange = (event) => {
    this.setState({ disputeStatus: event.target.value });
  };

  handleClose = () => {
    this.setState({ loading: false });
  };

  handleChangePage = (e, pageNo) => {
    this.setState({ pageNumber: pageNo });
    this.reloadTransactions(pageNo);
  };
  handleChangeRowPerPage = (data) => {};

  handleDownload = (id, name) => {
    ApiService.downloadDisputeFile(this.state.disputeId, id, name);
  };

  onMerchantChange = (event, newValue) => {
    let selMercht = newValue ? newValue : null;
    if (selMercht) {
      this.setState({
        selectedMerchant: selMercht,
      });
    } else {
      this.setState({
        selectedMerchant: null,
      });
    }
  };

  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };

  tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  searchTransactions = () => {
    this.setState({ pageNumber: 0 });

    if (
      this.state.fromDate === null ||
      this.state.toDate === null ||
      this.state.disputeStatus === "" ||
      this.state.selectedMerchant === null
    ) {
      this.setState({
        failed: true,
        responseMessage:
          "From Date,To date,Merchant and Dispute status are mandatory to select.",
      });
    } else {
      this.reloadTransactions(0);
    }
  };

  async reloadTransactions(pageNo) {
    this.setState({
      loading: true,
      result: [],
      totalRow: 0,
    });

    try {
      const res = await ApiService.fetchReportedDisputeTxns(
        format(this.state.fromDate, "yyyyMMdd"),
        format(this.state.toDate, "yyyyMMdd"),
        this.state.disputeStatus,
        this.state.selectedMerchant ? this.state.selectedMerchant.id : null,
        this.state.transactionId,
        this.state.numberRowPerPage,
        pageNo
      );

      if (res !== null) {
        this.setState({
          result: res.data.responseObject,
          loading: false,
          totalRow: res.data.totalRow,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching reported dispute transactions:", error);
      this.setState({
        loading: false,
      });
    }
  }

  disputeInfo = (dispTxnId) => {
    ApiService.fetchDisputeInfo(dispTxnId).then((res) => {
      if (res.data.status === "OK") {
        this.setState((prevState) => ({
          previousDisputeStatus: prevState.disputeStatus,
          disputeStatus: res.data.responseObject.status,
          evidenceType: res.data.responseObject.evidenceType,
          rejectReason: res.data.responseObject.rejectReason,
          files: res.data.responseObject.files,
          disputeId: res.data.responseObject.disputeId,
          firstName: res.data.responseObject.customerFirstName,
          lastName: res.data.responseObject.customerLastName,
          customerPhone: res.data.responseObject.customerPhone,
          address: res.data.responseObject.customerAddress,
          email: res.data.responseObject.customerEmail,
          isAccepted: res.data.responseObject.isAccepted,
        }));
      } else {
        this.setState({
          resMsg: res.data.responseMessage,
          failed3: true,
          disputeStatus: "",
          evidenceType: null,
          rejectReason: null,
        });
      }
    });
  };

  handleShowDetails = (data) => {
    let dispute = data.transactionId;
    this.setState({
      DetailPanelVisible: true,
      disputeTxnId: data.transactionId,
    });
    this.disputeInfo(dispute);
  };

  hideDetails = () => {
    this.setState({
      DetailPanelVisible: false,
      resMsg: null,
      failed3: false,
      disputeTxnId: null,
      success2: false,
      resMsg2: null,
      disputeId: null,
      disputeStatus: this.state.previousDisputeStatus,
      address: null,
      email: null,
      customerPhone: null,
    });
  };

  handleSettle = async () => {
    try {
      const res = await ApiService.fetchMarkSettled(this.state.disputeId);

      if (res.data.status === "OK") {
        this.setState({
          success2: true,
          resMsg2: res.data.responseMessage,
          disputeStatus: this.state.previousDisputeStatus,
        });
        setTimeout(async () => {
          await this.reloadTransactions(0);
        }, 1000);
      } else {
        this.setState({
          success2: false,
          resMsg2: res.data.responseMessage,
        });
      }
    } catch (error) {
      console.error("Error marking as settled:", error);
      this.setState({
        success2: false,
        resMsg2: "An error occurred while marking as settled.",
      });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      fromDate,
      toDate,
      transactionId,
      selectedMerchant,
      merchants,
      disputeStatus,
      loading,
    } = this.state;

    const fullName = this.state.firstName + " " + this.state.lastName;

    return (
      <>
        <Paper style={{ padding: "1em" }}>
          <PageTitle title="Dispute Transactions Info" />
          {this.state.failed && (
            <Alert severity="error" elevation={0}>
              {" "}
              {this.state.responseMessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation={0}>
              {" "}
              {this.state.responseMessage}
            </Alert>
          )}
          <Divider light className={classes.searchbar} />
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  label="From"
                  format="MM/dd/yyyy"
                  value={fromDate}
                  onChange={(val) => this.setState({ fromDate: val })}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  label="To"
                  format="MM/dd/yyyy"
                  value={toDate}
                  onChange={(val) => this.setState({ toDate: val })}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <TextField
                id="transactionId"
                label="TransactionId"
                variant="standard"
                value={transactionId}
                onChange={(e) =>
                  this.setState({ transactionId: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <FormControl>
                <Autocomplete
                  value={selectedMerchant}
                  onChange={this.onMerchantChange}
                  options={merchants}
                  getOptionLabel={(option) =>
                    option ? option.merchantName + "-" + option.code : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      labelId="merchantSelectLabel"
                      label="Merchants"
                      style={{ width: "150px" }}
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2} style={{ marginTop: "2px" }}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">
                  Dispute Status
                </InputLabel>
                <Select
                  style={{ fontSize: "12px", color: "#637562" }}
                  labelId="statusSelectLabel"
                  id="statusSelect"
                  value={disputeStatus}
                  onChange={this.handleStatusSelectChange}
                >
                  <MenuItem
                    style={{ fontSize: "12px", color: "#637562" }}
                    value={"ALL"}
                    dense
                  >
                    ALL
                  </MenuItem>
                  <MenuItem
                    style={{ fontSize: "12px", color: "#637562" }}
                    value={"DISPUTE_ACCEPTED"}
                    dense
                  >
                    DISPUTE_ACCEPTED
                  </MenuItem>
                  <MenuItem
                    style={{ fontSize: "12px", color: "#637562" }}
                    value={"DISPUTE_STARTED"}
                    dense
                  >
                    DISPUTE_STARTED
                  </MenuItem>
                  <MenuItem
                    style={{ fontSize: "12px", color: "#637562" }}
                    value={"DISPUTE_REJECTED"}
                    dense
                  >
                    DISPUTE_REJECTED
                  </MenuItem>
                  <MenuItem
                    style={{ fontSize: "12px", color: "#637562" }}
                    value={"DISPUTE_SETTLED"}
                    dense
                  >
                    DISPUTE_SETTLED
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginTop: "15px" }}
                onClick={this.searchTransactions}
                className={classes.button}
                startIcon={<SearchIcon style={{ fontSize: "1.2em" }} />}
              >
                Search
              </Button>
              <Backdrop
                open={loading}
                className={classes.backdrop}
                onClick={this.handleClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Grid>
          </Grid>

          <>
            {this.state.result.length === null ? (
              <Typography noWrap variant="caption">
                No data found!
              </Typography>
            ) : (
              <>
                <GridContainer style={{ marginTop: "2em", maxWidth: "100%" }}>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ marginTop: "4px" }}
                  >
                    <MaterialTable
                      title=""
                      icons={this.tableIcons}
                      components={{
                        Pagination: (props) => (
                          <TablePagination
                            {...props}
                            rowsPerPageOptions={[]}
                            rowsPerPage={this.state.numberRowPerPage}
                            count={this.state.totalRow}
                            page={this.state.pageNumber}
                            onChangePage={(e, page) =>
                              this.handleChangePage(e, page)
                            }
                            onRowsPerPageChange={(event) => {
                              //props.onChangeRowsPerPage(event);
                              this.handleChangeRowPerPage(event.target.value);
                            }}
                          />
                        ),
                      }}
                      columns={[
                        {
                          title: "Dispute Id",
                          field: "disputeId",
                          render: (rowData) => (
                            <>
                              <CustomTooltip
                                title={rowData.disputeId}
                                copy={true}
                              >
                                <InfoOutlinedIcon />
                              </CustomTooltip>
                            </>
                          ),
                        },
                        {
                          title: "Txn Id",
                          field: "transactionId",
                          render: (rowData) => (
                            <>
                              <CustomTooltip
                                title={rowData.transactionId}
                                copy={true}
                              >
                                <InfoOutlinedIcon />
                              </CustomTooltip>
                            </>
                          ),
                        },
                        {
                          title: "Dispute Info",
                          field: "disputeInfo",
                          render: (rowData) => (
                            <Typography noWrap variant="subtitle2">
                              {rowData.disputeInfo}
                            </Typography>
                          ),
                        },
                        {
                          title: "Customer Email",
                          field: "customerEmail",
                          render: (rowData) => (
                            <Typography noWrap variant="subtitle2">
                              {rowData.customerEmail}
                            </Typography>
                          ),
                        },
                        {
                          title: "Order No.",
                          field: "orderNo",
                          render: (rowData) => (
                            <>
                              <CustomTooltip
                                title={rowData.orderNo}
                                copy={true}
                              >
                                <InfoOutlinedIcon />
                              </CustomTooltip>
                            </>
                          ),
                        },
                        {
                          title: "Amount",
                          field: "amount",
                          type: "numeric",
                          render: (rowData) => (
                            <Typography variant="subtitle2">
                              {rowData.amount && rowData.amount.toFixed(2)}
                            </Typography>
                          ),
                        },
                        {
                          title: "Dispute Status",
                          field: "status",
                          render: (rowData) => (
                            <Typography noWrap variant="subtitle2">
                              {rowData.status}
                            </Typography>
                          ),
                        },
                      ]}
                      data={this.state.result}
                      options={{
                        search: true,
                        padding: "dense",
                        selection: false,
                        actionsColumnIndex: 12,
                        emptyRowsWhenPaging: false,
                        doubleHorizontalScroll: true,
                        initialPage: 0,
                        pageSize: this.state.numberRowPerPage,
                        headerStyle: {
                          whiteSpace: "nowrap",
                        },
                        cellStyle: {
                          whiteSpace: "nowrap",
                        },
                      }}
                      actions={[
                        (rowData) => ({
                          tooltip: "Search transaction",
                          icon: (props) => (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                            >
                              {" "}
                              Details{" "}
                            </Button>
                          ),
                          onClick: (evt, rowData) =>
                            this.handleShowDetails(rowData),
                        }),
                      ]}
                    />
                  </GridItem>
                </GridContainer>

                <Dialog
                  open={this.state.DetailPanelVisible}
                  onClose={this.hideDetails}
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogTitle color="primary">
                    <Typography variant="h6" color="primary">
                      Dispute Info
                    </Typography>
                  </DialogTitle>
                  {this.state.failed3 && (
                    <Alert severity="error" elevation={0}>
                      {this.state.resMsg}
                    </Alert>
                  )}
                  {this.state.success2 && (
                    <Alert severity="success" elevation={0}>
                      {this.state.resMsg2}
                    </Alert>
                  )}
                  <DialogContent>
                    {(this.state.disputeStatus === "DISPUTE_ACCEPTED" ||
                      this.state.disputeStatus === "DISPUTE_STARTED") && (
                      <>
                        <TextField2
                          label="Dispute Status"
                          value={this.state.disputeStatus}
                          InputProps={{ readOnly: true }}
                          InputLabelProps={{
                            shrink: !!this.state.disputeStatus,
                          }}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                        />

                        <TextField2
                          label="Full Name"
                          value={fullName}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <TextField2
                          label="Email"
                          fullWidth
                          margin="normal"
                          value={this.state.email}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <TextField2
                          label="Address"
                          fullWidth
                          margin="normal"
                          value={this.state.address}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                        <TextField2
                          label="Phone Number"
                          fullWidth
                          margin="normal"
                          value={this.state.customerPhone}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </>
                    )}

                    {(this.state.disputeStatus === "DISPUTE_REJECTED" ||
                      this.state.disputeStatus === "DISPUTE_SETTLED") && (
                      <>
                        <TextField2
                          label="Dispute Status"
                          value={this.state.disputeStatus}
                          InputProps={{ readOnly: true }}
                          InputLabelProps={{
                            shrink: !!this.state.disputeStatus,
                          }}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                        />

                        <TextField2
                          label="Full Name"
                          value={fullName}
                          fullWidth
                          margin="normal"
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: !!fullName,
                          }}
                        />
                        <TextField2
                          label="Email"
                          fullWidth
                          margin="normal"
                          value={this.state.email}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: !!this.state.email,
                          }}
                        />
                        <TextField2
                          label="Address"
                          fullWidth
                          margin="normal"
                          value={this.state.address}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: !!this.state.address,
                          }}
                        />
                        <TextField2
                          label="Phone Number"
                          fullWidth
                          margin="normal"
                          value={this.state.customerPhone}
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: !!this.state.customerPhone,
                          }}
                        />
                        {this.state.isAccepted === null && (
                          <>
                            <TextField2
                              label="Evidence Type"
                              value={this.state.evidenceType}
                              InputProps={{ readOnly: true }}
                              InputLabelProps={{
                                shrink: !!this.state.evidenceType,
                              }}
                              fullWidth
                              margin="normal"
                              variant="outlined"
                            />
                            <TextField2
                              label="Dispute Reject Reason"
                              value={this.state.rejectReason}
                              InputProps={{ readOnly: true }}
                              InputLabelProps={{
                                shrink: !!this.state.rejectReason,
                              }}
                              fullWidth
                              margin="normal"
                              variant="outlined"
                              multiline
                              rows={4}
                            />
                            <List>
                              <Typography variant="h6" color="primary">
                                Evidence Files :-
                              </Typography>
                              {this.state.files &&
                                this.state.files.map((file, index) => (
                                  <ListItem key={index} divider>
                                    <ListItemText primary={file.fileName} />
                                    <IconButton
                                      edge="end"
                                      color="primary"
                                      onClick={() =>
                                        this.handleDownload(
                                          file.fileId,
                                          file.fileName
                                        )
                                      }
                                    >
                                      <GetAppIcon />
                                    </IconButton>
                                  </ListItem>
                                ))}
                            </List>
                          </>
                        )}
                      </>
                    )}
                  </DialogContent>
                  <DialogActions>
                    {this.state.disputeStatus === "DISPUTE_STARTED" ||
                    this.state.disputeStatus === "DISPUTE_SETTLED" ||
                    this.state.resMsg2 === "Dispute Settelled Successfully!" ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CheckIcon />}
                        disabled
                      >
                        Mark as Settled
                      </Button>
                    ) : (
                      <Button
                        onClick={this.handleSettle}
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CheckIcon />}
                      >
                        Mark as Settled
                      </Button>
                    )}
                    <Button
                      onClick={this.hideDetails}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </>
        </Paper>
      </>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(DisputeInfoComponent);
